export default __webpack_public_path__ + "static/media/jorge.193c8f2c.png";